export const NavigationLocalize = {
  tasksLocalize: $localize`:@@tasks:Задачи`,
  technicalSupervisionLocalize: $localize`:@@technicalSupervision:Технадзор`,
  GASKLocalize: $localize`:@@GASK:ГАСК`,
  registryLocalize: $localize`:@@registry:Реестр`
}
